import { snapshotParams, snapshotVersionOf } from '@sb/database/snapshotParams';
import { assertSpaceItemPersistable } from '@sb/remote-control/util/assertSpaceItemPersistable';
import { convertGlobalSpaceResponse } from '@sb/remote-control/util/convertGlobalSpaceResponse';
import type { Space } from '@sb/routine-runner';

import { getGlobalSpaceService } from './utils/getGlobalSpaceService';

export async function updateGlobalSpace(
  globalSpaceID: string,
  updatedSpaceItem: Space.Item,
): Promise<Space.Item> {
  assertSpaceItemPersistable(updatedSpaceItem);

  const saved = await getGlobalSpaceService().patch(
    globalSpaceID,
    {
      spaceItem: updatedSpaceItem,
    },
    snapshotParams(snapshotVersionOf(updatedSpaceItem)),
  );

  const converted = convertGlobalSpaceResponse(saved);
  if (!converted) throw new Error('Saved global space could not be read.');

  return converted.spaceItem;
}
